import PropTypes from 'prop-types';
import { useMemo } from 'react';
import classNames from 'classnames';

import TeethLayoutConfig from './TeethLayoutConfig';
import Tooth from './Tooth';
import './ThootsStyle.scss';

export function TeethQuadrant({
  name,
  quadrantNumber,
  isChild = false,
  typeNomenclature = '',
  selectedTeeth = [],
  handleSelectTooth,
  disabled,
}) {
  const teeth = useMemo(
    () => TeethLayoutConfig[`quadrant${quadrantNumber}`][isChild ? 'child' : 'adult'],
    [isChild, quadrantNumber]
  );
  return (
    <div
      className={classNames('col col-md-6 quadrants')}
    >
      <div className={classNames('quadrant', `quadrant-${quadrantNumber}`)}>
        {teeth.map((toothNumber) => {
          return (
            <Tooth
              name={name}
              tooth={toothNumber}
              type={typeNomenclature}
              isSelected={selectedTeeth.includes(toothNumber)}
              onClickHandler={() => {
                if (!disabled) {
                  handleSelectTooth(toothNumber);
                }
              }}
              key={`tooth-${toothNumber}`}
              disabled={disabled}
            />
          );
        })}
      </div>
    </div>
  );
}

TeethQuadrant.propTypes = {
  name: PropTypes.string,
  quadrantNumber: PropTypes.number.isRequired,
  isChild: PropTypes.bool,
  typeNomenclature: PropTypes.string,
  selectedTeeth: PropTypes.array.isRequired,
  handleSelectTooth: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
export default TeethQuadrant;
